import styled, { css } from "styled-components"

export const StyledLabel = styled.label`
  padding-right: 0.5rem;
  ${requiredStyle}
  ${disabledStyle}
  ${getDisplay}
`

function getDisplay({ $inline }) {
  if (!$inline) {
    return css`
      display: block;
    `
  } else return css``
}
function requiredStyle({ required }) {
  if (!required) return css``

  return css`
    &::after {
      content: " *";
    }
  `
}
function disabledStyle({ disabled, theme }) {
  if (!disabled) return css``

  return css`
    color: ${theme.colors.disabled.fg};
  `
}
